const getBrowserId = (): string => {
  let retrievedBrowserId = localStorage.getItem('browser_id');

  if (!retrievedBrowserId) {
    // retrievedBrowserId = self.crypto.randomUUID();
    retrievedBrowserId = '8e3f0a9b-1c2d-4e5f-a6b7-8c9d0e1f2a3b';
    localStorage.setItem('browser_id', retrievedBrowserId);
  }
  return retrievedBrowserId;
};

export default getBrowserId;
